import React from 'react';
import { ExternalLink } from 'lucide-react';
import { SocialLink as SocialLinkType } from '../types';

interface SocialLinkProps {
  platform: SocialLinkType['platform'];
  url: string;
  title?: string;
  onClick?: () => void;
}

const platformConfig = {
  shopee: {
    name: 'Shopee',
    color: 'bg-gradient-to-r from-orange-500 to-red-500',
    icon: '🛒'
  },
  instagram: {
    name: 'Instagram',
    color: 'bg-gradient-to-r from-purple-500 to-pink-500',
    icon: '📷'
  },
  x: {
    name: 'X (Twitter)',
    color: 'bg-gradient-to-r from-gray-800 to-gray-600',
    icon: '🐦'
  },
  facebook: {
    name: 'Facebook',
    color: 'bg-gradient-to-r from-blue-600 to-blue-500',
    icon: '👥'
  },
  threads: {
    name: 'Threads',
    color: 'bg-gradient-to-r from-gray-900 to-gray-700',
    icon: '🧵'
  },
  tiktok: {
    name: 'TikTok',
    color: 'bg-gradient-to-r from-black to-red-600',
    icon: '🎵'
  },
  custom: {
    name: 'Link',
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500',
    icon: '🔗'
  }
};

export function SocialLink({ platform, url, title, onClick }: SocialLinkProps) {
  const config = platformConfig[platform];
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="group block w-full"
    >
      <div className={`${config.color} rounded-lg p-4 shadow-sm transform transition-all duration-300 group-hover:scale-[1.02] group-hover:shadow-md`}>
        <div className="flex items-center justify-between text-white">
          <div className="flex items-center gap-3">
            <span className="text-xl">{config.icon}</span>
            <div>
              <div className="font-medium">
                {title || config.name}
              </div>
            </div>
          </div>
          <ExternalLink className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity" />
        </div>
      </div>
    </a>
  );
}
